import { render, staticRenderFns } from "./AdmissionQuery.vue?vue&type=template&id=d30f2ffc&scoped=true"
import script from "./AdmissionQuery.vue?vue&type=script&lang=js"
export * from "./AdmissionQuery.vue?vue&type=script&lang=js"
import style0 from "./AdmissionQuery.vue?vue&type=style&index=0&id=d30f2ffc&prod&lang=css"
import style1 from "./AdmissionQuery.vue?vue&type=style&index=1&id=d30f2ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30f2ffc",
  null
  
)

export default component.exports